import type { FC } from "react"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import {
  Box,
  Step,
  Stepper,
  StepLabel,
  Button,
} from "../../../components/mui.components"
import { Warning, Info } from "@mui/icons-material"
import { useAppDispatch, useAppSelector } from "@/core/app/hooks"
import { RootState } from "@/core/app/store"
import { ReactSVG } from "react-svg"

import SegSvg from "@/UDTreat/assets/topautostep/seg.svg"
import SegClickSvg from "@/UDTreat/assets/topautostep/seg_click.svg"
import LableSvg from "@/UDTreat/assets/topautostep/lable.svg"
import LableClickSvg from "@/UDTreat/assets/topautostep/lable_click.svg"
import BiteSvg from "@/UDTreat/assets/topautostep/bitereg.svg"
import BiteClickSvg from "@/UDTreat/assets/topautostep/bitereg_click.svg"
import SpaceSvg from "@/UDTreat/assets/topautostep/spacing.svg"
import SpaceClickSvg from "@/UDTreat/assets/topautostep/spacing_click.svg"
import OrientationSvg from "@/UDTreat/assets/topautostep/orientation.svg"
import OrientationClickSvg from "@/UDTreat/assets/topautostep/orientation_click.svg"

const AutoModelCheck: FC = () => {
  const dispatch = useAppDispatch()
  const { autoProActiveStep } = useAppSelector(
    (state: RootState) => state.udTreatService,
  )
  const stepTmp = [
    {
      id: "check-segmentation",
      label: "Check Segmentation",
      icon: SegSvg,
      activeIcon: SegClickSvg,
      index: 0,
    },
    {
      id: "check-label",
      label: "Check Label",
      icon: LableSvg,
      activeIcon: LableClickSvg,
      index: 1,
    },
    {
      id: "check-bitereg",
      label: "Check Bite Reg",
      icon: BiteSvg,
      activeIcon: BiteClickSvg,
      index: 2,
    },
    {
      id: "check-space",
      label: "Check Space",
      icon: SpaceSvg,
      activeIcon: SpaceClickSvg,
      index: 3,
    },
    {
      id: "adjust-orientation",
      label: "Adjust Orientation",
      icon: OrientationSvg,
      activeIcon: OrientationClickSvg,
      index: 4,
    },
  ]

  const { t } = useTranslation("common")

  return (
    <Box
      sx={{
        width: "35%",
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        justifyContent: "center",
      }}
    >
      <Stepper activeStep={autoProActiveStep} orientation="horizontal">
        {stepTmp.map((i) => (
          <Step key={i.id}>
            <StepLabel
              icon={
                <ReactSVG
                  src={i.index === autoProActiveStep ? i.activeIcon : i.icon}
                  style={{
                    width: 24,
                    height: 24,
                    display: "block",
                  }}
                />
              }
              sx={{
                position: "relative",
                alignItems: "center",
                "& .MuiStepLabel-label": {
                  position: "absolute",
                  color: "white !important",
                  left: "50%",
                  transform: "translateX(-50%)",
                  top: "100%", // 放在 icon 下方
                  mt: "12px", // 间距
                  whiteSpace: "nowrap",
                  fontSize: 12,
                  fontWeight: 500,
                  display: i.index === autoProActiveStep ? "block" : "none", // 仅当前步骤显示
                },
              }}
            >
              {i.label}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  )
}
export default AutoModelCheck
